export enum RequestContext {
  BARCODE_SCANNER,
  CHECK_IN_CODE,
  SDK,
  SEARCH_CUSTOMERS,
}
